import { useQuery } from '@tanstack/react-query';
import { reservationPublicService } from '../services/reservation-system/reservation-public.service';
import type { RsCountryCode } from '../constants/rsCountryCodes';

/** 共有トークン向け board / bookings / holidays の取得 */
export function useRsBoardShareQueries(
  shareToken: string,
  year: number,
  month: number,
  holidayCountryCode: RsCountryCode,
  enabled: boolean
) {
  const boardQuery = useQuery({
    queryKey: ['reservation-board-share', shareToken],
    queryFn: () => reservationPublicService.getBoard(shareToken),
    enabled,
    staleTime: 30_000,
  });

  const boardReady = enabled && Boolean(boardQuery.data);

  const bookingsQuery = useQuery({
    queryKey: ['reservation-bookings-share', shareToken, year, month],
    queryFn: () => reservationPublicService.listBookings(shareToken, year, month),
    enabled: boardReady,
    staleTime: 10_000,
  });

  const holidaysQuery = useQuery({
    queryKey: ['reservation-holidays-share', shareToken, year, month, holidayCountryCode],
    queryFn: () =>
      reservationPublicService.getHolidays(shareToken, year, month, holidayCountryCode),
    enabled: boardReady,
    staleTime: 86_400_000,
  });

  return { boardQuery, bookingsQuery, holidaysQuery };
}
